import { gql } from 'graphql-request';

export default gql`
  mutation callflowCreate($data: JSON) {
    callflowCreate(data: $data) {
      success
      message
      data
    }
  }
`;
